// components/DeleteConfirm.tsx
import React, { useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { del } from '../../../hook/request';
import { toast } from 'react-toastify';

type DeleteConfirmProps = {
  url?: string;
  onConfirm?: () => Promise<void>;
  successMessage?: string;
  errorMessage?: string;
  trigger?: React.ReactNode;
  onError?: (err: unknown) => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  triggerClassName?: string;
  onSuccess?: () => void;
};

const DeleteConfirm: React.FC<DeleteConfirmProps> = ({
  url,
  onConfirm,
  successMessage = 'Eliminato con successo',
  errorMessage = "Errore durante l'eliminazione",
  trigger,
  onSuccess,
  onError,
  title = 'Conferma eliminazione',
  message = 'Sei sicuro di voler eliminare?',
  confirmText = 'Elimina',
  cancelText = 'Annulla',
  triggerClassName = 'btn btn-sm btn-outline-danger',
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const pending = useRef(false);
  const toggle = () => { if (!pending.current) setOpen(v => !v); };

  const handleConfirm = async () => {
    if (pending.current) return;
    pending.current = true;
    try {
      setLoading(true);
      if (onConfirm) await onConfirm();
      else if (url) await del<any>(url);
      else throw new Error('Azione di conferma non configurata');
      toast.success(successMessage);
      setOpen(false);
      onSuccess?.();
    } catch (err) {
      toast.error(errorMessage);
      onError?.(err);
    } finally {
      pending.current = false;
      setLoading(false);
    }
  };

  return (
    <>
      {trigger ? (
        <span onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
          {trigger}
        </span>
      ) : (
        <button type="button" className={triggerClassName} onClick={() => setOpen(true)}>
          <i className="fa-solid fa-trash me-1" />
          Elimina
        </button>
      )}

      <Modal isOpen={open} toggle={toggle} backdrop={loading ? "static" : true} keyboard={!loading} centered>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <Button color="light"  style={{color:'black'}} onClick={toggle} disabled={loading}>
            {cancelText}
          </Button>
          <Button color="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? <Spinner size="sm" /> : confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DeleteConfirm;
